import { FriendReferralState } from "./types";

export const initialState: FriendReferralState = {
	isCheckingFr: true
};
